import dayjs, { Dayjs } from "dayjs";
import { atom } from "jotai";
import { TipoMovimentacaoEnum } from "../enums/TipoMovimentacaoEnum";
import { Movimentacao } from "../types/Movimentacao";
import { Planejamento } from "../types/Planejamento";
import { criaMovimentacaoVazia } from "../utils/MovimentacaoUtils";

export const accessToken = atom("" as string | null);
export const pictureAtom = atom(localStorage.getItem("urlPicture") as string | null);
export const saldo = atom(0 as number);
export const modalPlanajamento = atom(false as boolean);
export const modalAddMovimentacao = atom(false as boolean);
export const modalMovimentacao = atom('' as TipoMovimentacaoEnum);
export const modalRemoveMovimentacao = atom(false as boolean);
export const modalLogin = atom(false as boolean);
export const modalEditSaldo = atom(false as boolean);
export const modalTutoriais = atom(false as boolean);
export const modalCategorias = atom(false as boolean);
export const planejamento = atom({} as Planejamento);
export const movimentacaoAtom = atom<Movimentacao>(criaMovimentacaoVazia());
export const movimentacaoApagar = atom<Movimentacao | null>(null);
export const movimentacoesMes = atom<Movimentacao[]>([]);
export const dataSelecionada = atom<Date>(new Date());
export const valoresVisiveis = atom(false as boolean);
export const movementSearchText = atom("" as string);
export const analyticsYear = atom<Dayjs | null>(dayjs());
export const analyticsFullYear = atom(false as boolean);